var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"header-style"},[_vm._v("\n    Check-in Records\n  ")]),_c('p',{staticClass:"subheader-style"},[_vm._v("\n    List of your check-in activities\n  ")]),_c('br'),_c('user-activity')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }